import { Fragment, useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { useInfiniteScroll } from 'react-infinite-scroll-hook'
import { Stack, Card, Popover, Text, Inline } from '@leroy-merlin-br/backyard-react-ui'

import { error } from 'scripts/utils/message'

import { Icon } from 'lmcv/components/Icon'
import { List } from 'lmcv/components/BalanceList'
import { Skeleton } from 'lmcv/components/Skeleton'
import { getProfileLoyalty, getProfileBalance } from 'lmcv/services/profile'
import { message } from 'lmcv/modules/helpers'

import { IconToolTip } from './components/IconToolTip'
import { Points } from './components/Points'
import { TimeLine } from './components/TimeLine'

function MyPointsPagePro () {
  const [user, setUser] = useState({})
  const [userLoading, setUserLoading] = useState(true)
  const [balance, setBalance] = useState([])
  const [loading, setLoading] = useState(false)
  const [getting, setGetting] = useState(false)
  const [listLoading, setListLoading] = useState(true)

  const [hasNextPage, setHasNextPage] = useState(true)
  const [page, setPage] = useState(1)

  useEffect(() => {
    getProfileLoyalty()
      .then(data => {
        setUser(data)
        setUserLoading(false)
      })
      .catch(e => error(message.error('seu perfil')))
  }, [])

  const handleLoadMore = () => {
    setLoading(true)

    getProfileBalance(page)
      .then(({ data, meta }) => {
        if (!meta.next_page) {
          setHasNextPage(false)
        }

        if (meta.current_page > 1) {
          setGetting(true)
        }

        setPage(page + 1)
        setGetting(false)
        setBalance([...balance, ...data])
      })
      .catch(e => error(message.error('seu saldo de pontos')))
      .finally(() => {
        setLoading(false)
        setListLoading(false)
      })
  }

  const ListRef = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: handleLoadMore,
    scrollContainer: 'window',
    threshold: 600
  })

  if (userLoading) {
    return ''
  }

  if (user.status === 7) {
    return (
      <Stack>
        <Card title="Meus Pontos">
          <Points user={user} isLoading={userLoading} />
        </Card>

        <Card
          title={
            <Fragment>
              Meus Objetivos
              <Popover
                title="Como funcionam os Meus Objetivos?"
                content={
                  <Fragment>
                    <Text size="kilo">
                      O valor gasto em reais pelos seu(s) Cliente(s) no projeto
                      são acumulados durante o prazo determinado. Ao atingir
                      cada uma das missões, você ganha a recompensa em pontos.
                    </Text>

                    <Text size="kilo">
                      Ao final do prazo, o valor de todas as compras dos seus
                      Clientes reinicia e você recebe a recompensa de acordo com
                      a missão atingida.
                    </Text>
                  </Fragment>
                }
                placement="bottom"
              >
                <IconToolTip />
              </Popover>
            </Fragment>
          }
        >
          <Text>
            {userLoading
              ? (
              <Skeleton width="190px" height="14px" />
                )
              : (
              <Inline align="center" justify="start" spacing="bit">
                <Icon name="clock" width={12} height={12} />
                <Text size="kilo" noMargin>Termina em: {user.seasonEndsAt}</Text>
              </Inline>
                )}
          </Text>
          <TimeLine data={user} isLoading={userLoading} />
        </Card>

        <Card title="Saldo de pontos">
          <div ref={ListRef}>
            <List data={balance} isLoading={listLoading} isGetting={getting} />
          </div>
        </Card>
      </Stack>
    )
  }

  return <Redirect to="/meus-pontos" />
}

export default MyPointsPagePro
